

import axios from 'axios'



export const getBuurtInfo = () => {
  let buurten = require('@/data/buurt_data.json');

  buurten = buurten.result.reduce((result, item) => {

    result[item.BU_CODE] = {
      naam: item.buurt_naam,
      gem_inkomen: item.gemiddeld_inkomen_per_inkomensontvanger2017,
      huishoudens: item.aantal_huishoudens_2019,
      inwoners: {
        totaal: item.aantal_inwoners_2019,
        allochtonen: item.percentage_niet_westerse_migratieachtergrond_2019,
        '0-25': item.percentage_personen_0_tot_25_jaar_2019,
        '65+': item.percentage_personen_65_jaar_en_ouder_2019,
        uitkering: item.percentage_personen_uitkering_2017
      },
      functies: {
        bijeenkomsten: item.bijeenkomstfunctie_aantal,
        industrie: item.industriefunctie_aantal,
        kantoor: item.kantoorfunctie_aantal,
        logies: item.logiesfunctie_aantal,
        onderwijs: item.onderwijsfunctie_aantal,
        overige: item['overige gebruiksfunctie_aantal'],
        sport: item.sportfunctie_aantal,
        winkel: item.winkelfunctie_aantal,
        woning: item.woonfunctie_aantal,
        zorg: item.gezondheidszorgfunctie_aantal
      },
      coordinates: item.coordinates // TODO: Ask Jelmer for bounds... 
    }

    return result
  }, {})

  return buurten
}

export const getBuurtPandInfo = ({ municipality, neighborhood }) => {
  return axios.get(`/data/${municipality}_${neighborhood}_data.json`)
}